import React, { useState } from "react";
import { Box } from "@mui/material";

const box = {
	backgroundColor: "#e0f7fa",
	border: "2px solid #59c3d8",
	borderRadius: 16,
	padding: "12px",
};
const h3 = {
	fontFamily: '"Poppins", sans-serif',
	fontSize: 14,
	fontWeight: 700,
	textTransform: "uppercase",
	marginBottom: 8,
	color: "#007a8d",
};
const ul = { paddingLeft: 18, margin: 0, fontFamily: '"Poppins", sans-serif' };

const defaultPlaces = [
	{ name: "Empire State", price: 45 },
	{ name: "Top of the Rock", price: 40 },
	{ name: "Estatua de la Libertad", price: 25 },
	{ name: "One World Observatory", price: 45 },
	{ name: "MoMA (Museo de Arte Moderno)", price: 30 },
	{ name: "Museo de Historia Natural", price: 28 },
	{ name: "Edge Hudson Yards", price: 45 },
	{ name: "Crucero turístico", price: 35 },
	{ name: "Bus turístico Hop-on Hop-off", price: 65 },
];

const defaultPasses = [
	{
		nombre: "🎟 CityPASS y New York C3 by CityPASS",
		puntos: [
			"CityPASS: entrada a 5 atracciones top de Nueva York. 2 son fijas y puedes elegir 3 más.",
			"New York C3: eliges 3 atracciones entre unas 10 disponibles, ideal para viajes cortos.",
			"Flexible: no es necesario usarlo en días consecutivos.",
			"Incluyen: Empire State, Museo Historia Natural, Top of the Rock, Estatua de la Libertad, cruceros...",
		],
	},
];

// Template96: Calculadora pases NY (guia-ny PassCalculator). Contenido desde page.
const Template96 = ({
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const [selectedPlaces, setSelectedPlaces] = useState([]);
	const [totalPrice, setTotalPrice] = useState(null);

	const headerText =
		page?.texts?.[0]?.content ?? "Calculadora: ¿te sale a cuenta el pase?";
	const calculatorTitle =
		page?.texts?.[1]?.content ?? "¿Qué lugares quieres visitar?";
	const buttonText = "Calcular precio total";
	const resultHighHtml = page?.texts?.[3]?.content;
	const resultLowHtml = page?.texts?.[4]?.content;
	const places =
		Array.isArray(page?.places) && page.places.length > 0
			? page.places
			: defaultPlaces;
	const passes =
		Array.isArray(page?.passes) && page.passes.length > 0
			? page.passes
			: defaultPasses;
	const threshold =
		page?.calculatorThreshold != null ? Number(page.calculatorThreshold) : 130;

	const togglePlace = (placeName) => {
		if (selectedPlaces.includes(placeName)) {
			setSelectedPlaces(selectedPlaces.filter((p) => p !== placeName));
		} else {
			setSelectedPlaces([...selectedPlaces, placeName]);
		}
	};

	const calculateTotal = () => {
		const total = places
			.filter((p) => selectedPlaces.includes(p.name))
			.reduce((sum, p) => sum + p.price, 0);
		setTotalPrice(total);
	};

	const renderResult = () => {
		if (totalPrice === null) return null;
		const useHigh = totalPrice > threshold;
		if (useHigh && resultHighHtml) {
			return (
				<div
					dangerouslySetInnerHTML={{
						__html: resultHighHtml.replace(/\{\{total\}\}/g, totalPrice),
					}}
				/>
			);
		}
		if (!useHigh && resultLowHtml) {
			return (
				<div
					dangerouslySetInnerHTML={{
						__html: resultLowHtml.replace(/\{\{total\}\}/g, totalPrice),
					}}
				/>
			);
		}
		return (
			<>
				El precio de tus entradas sería aproximadamente{" "}
				<strong>{totalPrice} €</strong>.
				<br />
				{useHigh
					? "¡Te interesa mirar un pase turístico!"
					: "No necesitas pase, mejor entradas sueltas."}
			</>
		);
	};

	return (
		<Box
			sx={{
				height: "100%",
				backgroundColor: "#f7f7f7",
				display: "flex",
				flexDirection: "column",
				"& *": {
					fontFamily: (fontFamily || '"Poppins", sans-serif') + " !important",
				},
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontFamily: fontFamily || '"Poppins", sans-serif',
					fontSize: "14px",
					fontWeight: 700,
				}}
			>
				{headerText}
			</div>
			<div data-block-id="text-1" style={{ padding: "20px 16px", flex: 1, overflowY: "auto" }}>
				<div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
					{passes.map((pase, index) => (
						<div
							key={index}
							style={{
								backgroundColor: "#fff",
								borderRadius: "12px",
								border: "2px solid #e0f7fa",
								padding: "14px",
								fontSize: "13px",
								color: "#444",
							}}
						>
							<strong style={{ fontSize: "14px" }}>{pase.nombre}</strong>
							<ul style={{ ...ul, marginTop: "8px", paddingLeft: "20px" }}>
								{Array.isArray(pase.puntos) &&
									pase.puntos.map((punto, idx) => <li key={idx}>{punto}</li>)}
							</ul>
						</div>
					))}
				</div>
				<div data-block-id="text-2" style={{ ...box, marginTop: 12 }}>
					<h2
						style={{
							...h3,
							marginTop: 0,
							paddingTop: 0,
							textAlign: "center",
						}}
					>
						{calculatorTitle}
					</h2>
					<div
						style={{
							display: "flex",
							flexWrap: "wrap",
							gap: "10px",
							justifyContent: "center",
							marginBottom: "8px",
						}}
					>
						{places.map((place, index) => (
							<div
								key={index}
								onClick={() => togglePlace(place.name)}
								style={{
									padding: "2px 8px",
									borderRadius: "12px",
									border: selectedPlaces.includes(place.name)
										? "2px solid #59c3d8"
										: "2px solid #e8e8e8",
									backgroundColor: selectedPlaces.includes(place.name)
										? "#e0f7fa"
										: "#fff",
									cursor: "pointer",
									fontSize: "12px",
									fontFamily: '"Poppins", sans-serif',
								}}
							>
								{place.name}
							</div>
						))}
					</div>
					<div
						style={{
							textAlign: "center",
							marginBottom: "14px",
							marginTop: "14px",
						}}
					>
						<button
							onClick={calculateTotal}
							disabled={selectedPlaces.length === 0}
							style={{
								backgroundColor:
									selectedPlaces.length === 0 ? "#ccc" : "#59c3d8",
								color: "#fff",
								border: "none",
								padding: "10px 20px",
								borderRadius: "12px",
								fontSize: "14px",
								fontFamily: '"Poppins", sans-serif',
								cursor: "pointer",
							}}
						>
							{buttonText}
						</button>
					</div>
					{totalPrice !== null && (
						<div
							style={{
								marginTop: "6px",
								padding: "12px",
								backgroundColor: "#fff",
								border: "2px solid #59c3d8",
								borderRadius: "12px",
								textAlign: "center",
								fontFamily: '"Poppins", sans-serif',
								color: "#444",
								fontSize: "13px",
							}}
						>
							{renderResult()}
						</div>
					)}
				</div>
			</div>
		</Box>
	);
};

export default Template96;
